import { NgModule, Optional, SkipSelf, ModuleWithProviders } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import {
  LimitlessUiService,
  LoggerService,
  EnvironmentService,
  ConstantsService,
  SessionService,
  LookupsService,
} from '@app/core/services';

import {
  SocoModule,
  SocoConfigurationService,
  SocoHttpService,
  SocoAlertService
} from '@app/base/soco';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    SocoModule
  ],
  exports: [
    CommonModule,
    RouterModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    SocoModule
  ],
  providers: [
    EnvironmentService,
    ConstantsService,
    LoggerService,
    LimitlessUiService,
    SessionService,
    LookupsService,
    SocoConfigurationService,
    SocoHttpService,
    SocoAlertService
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) { throw new Error('CoreModule is already loaded. Import it in the AppModule only'); }
  }

  static forRoot(): ModuleWithProviders<NgModule> {
    return {
      ngModule: CoreModule,
      // Singleton service for the entire app.
      providers: [
        // App Services
        { provide: EnvironmentService },
        { provide: ConstantsService },
        { provide: LoggerService },
        { provide: LimitlessUiService },
        { provide: SessionService },
        { provide: LookupsService },
        // SoCo Services
        { provide: SocoConfigurationService },
        { provide: SocoHttpService },
        { provide: SocoAlertService }
      ]
    };
  }
}
